import { changeBackgroundColor } from '../util/backgroundColorUtil';

export default class ColorField {
    #icon =
        '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-5 w-5">' +
        '<path stroke-linecap="round" stroke-linejoin="round" d="M15 11.25l1.5 1.5.75-.75V8.758l2.276-.61a3 3 0 10-3.675-3.675l-.61 2.277H12l-.75.75 1.5 1.5M15 11.25l-8.47 8.47c-.34.34-.8.53-1.28.53s-.94.19-1.28.53l-.97.97-.75-.75.97-.97c.34-.34.53-.8.53-1.28s.19-.94.53-1.28L12.75 9M15 11.25L12.75 9" />' +
        '</svg>';

    constructor(document, themePreviewContainer) {
        this.document = document;
        this.colorElementsSelector = 'input[type=color]';
        this.domParser = new DOMParser();
        this.themePreviewContainer = themePreviewContainer || '#theme-preview';
        this.elements = Array.from(this.document.querySelectorAll(this.colorElementsSelector));
    }

    bind() {
        for (const element of this.elements) {
            if (element.dataset.bound === 'true') {
                continue;
            }

            const wrapper = this.document.createElement('div');
            const input = this.document.createElement('input');
            const colorPickerButton = this.document.createElement('div');
            wrapper.append(input);
            wrapper.append(colorPickerButton);

            wrapper.classList.add('relative', 'p-0');

            input.type = 'text';
            input.value = element.value;
            input.classList.add('form-field');
            input.id = `${element.id}_text`;
            input.addEventListener('input', () => {
                element.value = input.value;
                const event = new Event('input');
                element.dispatchEvent(event);

                if (element.value.length === 7) {
                    changeBackgroundColor(input, element.value);
                    changeBackgroundColor(colorPickerButton, element.value);
                }
            });

            const label = this.document.querySelector(`[for="${element.id}"]`);
            label.setAttribute('for', input.id);

            colorPickerButton.append(this.domParser.parseFromString(this.#icon, 'image/svg+xml').querySelector('svg'));
            colorPickerButton.classList.add('w-5', 'h-5', 'absolute', 'right-[10px]', 'top-[10px]', 'cursor-pointer');
            colorPickerButton.addEventListener('click', () => {
                element.click();
            });

            const changeListener = () => {
                input.value = element.value;
                changeBackgroundColor(input, element.value);
                changeBackgroundColor(colorPickerButton, element.value);
            };

            element.addEventListener('change', changeListener);

            changeBackgroundColor(input, element.value);
            changeBackgroundColor(colorPickerButton, element.value);
            element.after(wrapper);
            element.classList.add('hidden');
            element.classList.remove('form-field');

            element.dataset.bound = 'true';
        }
    }
}

document.addEventListener('click', () => {
    new ColorField(document).bind();
});

new ColorField(document).bind();
